//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixinTxrNewWeb, { privateKeyMap } from "@/utils/mixin/mixinTxrNewWeb";
import { insuranceConfirm } from "@/model/javaApi/detail.js";
import mixinVerify from "@/utils/mixin/mixinVerify";
export default {
  name: "confirmed",
  mixins: [mixinTxrNewWeb, mixinVerify],
  data() {
    return {
      list: [],
      listShow: [true, true, true],
      buttons: [],
    };
  },
  created() {
    console.log("投保参数", this.insuranceParmes);
    if (!this.insuranceParmes || !this.insuranceParmes.price) {
      this.$toast("投保信息丢失，请重新投保");
      setTimeout(() => {
        this.$router.go(-1);
      }, 2000);
    }
    this.getData();
  },
  computed: {
    insuranceParmes() {
      //投保信息
      return this.getPostData();
    },
    commodityCode() {
      //渠道商品CODE
      return this.$route.query.commodityCode;
    },
    insureCode() {
      //险种CODE
      return this.$route.query.insureCode || "";
    },
    reviewType() {
      //订单类型
      return this.$route.query.reviewType || "";
    },
  },
  mounted() {
    this.STATISTICS_CONFIG.insur_keynotice_page();
    // 回溯节点
    this.$nextTick(() => {
      // 回溯视频
      const { productCode } = this.$route.query.productCode;
      this.confirmedTX(
        productCode && privateKeyMap[productCode]
          ? productCode
          : this.channelCommodityCode
      );
    });
  },
  methods: {
    // 获取协议
    getData() {
      const data = {
        commodityCode: this.commodityCode,
        insureCode: this.insureCode,
      };
      insuranceConfirm(data).then((res) => {
        this.list = res.list;
        this.buttons = res.buttons;
      });
    },
    show(index) {
      if (this.listShow[index]) {
        this.STATISTICS_CONFIG.insur_keynotice_expand_click(); //展开按钮
      } else {
        this.STATISTICS_CONFIG.insur_keynotice_retract_click(); //收起按钮
      }
      this.$set(this.listShow, index, !this.listShow[index]);
    },
    goback() {
      this.STATISTICS_CONFIG.insur_keynotice_no_click();
      this.$router.go(-1);
    },
    btnClick() {
      this.STATISTICS_CONFIG.insur_keynotice_yes_click();
      // 创建订单
      this.mixinCreatAnOrder(() => {
        this.$router.push({
          path: "/detailPaySuccess",
          query: {
            flag: "postdisable",
          },
        });
      });
    },
  },
};
